import { render } from "./DeleteCompanyModal.vue?vue&type=template&id=e1c98b4c"
import script from "./DeleteCompanyModal.vue?vue&type=script&lang=ts"
export * from "./DeleteCompanyModal.vue?vue&type=script&lang=ts"
script.render = render

export default script